import { render, staticRenderFns } from "./DuoBarChart.vue?vue&type=template&id=47250cd6"
import script from "./DuoBarChart.vue?vue&type=script&lang=js"
export * from "./DuoBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports